export default "__VITE_ASSET__BFfdn1f1__"